'use client';
import { useBreakpoints } from '@/hooks/useBreakpoints';
import { ActionIcon, Badge, Menu, ScrollArea } from '@mantine/core';

import EmptyNotification from '@/components/common/empty-states/empty-notification';
import NotificationSkeleton from '@/components/common/skeleton-effect/notification-skeleton';
import { setIsClear } from '@/lib/features/notification/notificationSlice';
import axios from 'axios';
import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import style from './notification.module.scss';
import { dateOnlyFormat, timeFormat } from '@/lib/utils/date';

const Notifications = () => {
    const { smDevice, xxsDevice, xsDevice } = useBreakpoints();
    const { accountType } = useSelector((state) => state.session);
    const [notificationData, setNotificationData] = useState([]);
    const [error, setError] = useState({ message: '', variant: '' });
    const [loading, setLoading] = useState(false);
    const { remoteId } = useSelector((state) => state.session);
    const { languageData } = useSelector((state) => state.language);
    const common = languageData?.text?.common;
    const { alertData, isClear } = useSelector((state) => state.notification);
    const dispatch = useDispatch();

    const fetchNotificationData = async () => {
        if (!remoteId) return;
        setLoading(true);
        setError({ message: '', variant: '' });
        const params = {
            casino: process.env.NEXT_PUBLIC_CASINO,
            AUTH_ID: remoteId,
            isRead: false,
            page: 1,
            limit: 5000,
        };
        try {
            const response = await axios.get(`${process.env.NEXT_PUBLIC_API_DOMAIN}/api/notifications/get`, {
                params,
            });
            const res = response?.data;
            if (res?.status === 200) {
                if (res?.data?.length > 0) {
                    setNotificationData(res?.data);
                    setError({ message: '', variant: '' });
                } else {
                    setNotificationData([]);
                    setError({ message: common?.no_data_msg, variant: 'info' });
                }
            } else {
                setError({ message: res?.message, variant: 'danger' });
            }
        } catch (error) {
            setError({ message: error.message, variant: 'danger' });
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (common && Object.keys(common).length > 0) fetchNotificationData();
    }, [remoteId, common, alertData, isClear]);

    const clearAllNotification = async () => {
        dispatch(setIsClear(true));
        const params = {
            casino: process.env.NEXT_PUBLIC_CASINO,
            AUTH_ID: remoteId,
            ids: notificationData?.map((v) => v?.id)?.join(','),
        };
        try {
            const response = await axios.patch(`${process.env.NEXT_PUBLIC_API_DOMAIN}/api/notifications/markAsRead`, null, {
                params,
            });
            const res = response?.data;
            if (res?.status === 200) {
                fetchNotificationData();
            } else {
            }
        } catch (error) {
            console.log(error?.message);
        } finally {
            dispatch(setIsClear(false));
        }
    };


    return (
        <>
            <Menu width={!smDevice ? 300 : 500} classNames="theme_menu" arrowOffset={50} arrowSize={10} withArrow position="bottom">
                <Menu.Target>
                    <div className={style.notification_btn}>
                        <ActionIcon size={smDevice ? 50 : xxsDevice ? 40 : 40} variant="default" radius="xl">
                            <Image src="/images/icons/notification.svg" width={smDevice ? 24 : xxsDevice ? 18 : 16} height={smDevice ? 24 : xxsDevice ? 18 : 16} alt="notification" style={{height: `${smDevice ? 1.5 : xxsDevice ? 1.125 : 1}rem`, width: `${smDevice ? 1.5 : xxsDevice ? 1.125 : 1}rem`}}  />
                        </ActionIcon>
                        {notificationData?.length > 0 && (
                            <Badge size={xsDevice ? 'md' : 'sm'} className={clsx(style.number_badge, 'badge_primary')} circle>
                                {notificationData?.length}
                            </Badge>
                        )}
                    </div>
                </Menu.Target>
                <Menu.Dropdown>
                    <div className={style.menu_dropdown}>
                        {notificationData?.length === 0 ? (
                            <EmptyNotification />
                        ) : (
                            <>
                                {loading ? (
                                    <NotificationSkeleton count={3} />
                                ) : (
                                    <>
                                        <ScrollArea className={style.notification_scroll}>
                                            {notificationData.map((v, i) => (
                                                <Menu.Item
                                                    key={i}
                                                    leftSection={
                                                        <div className={style.profile_avatar}>
                                                            <span>{v?.sender?.username?.slice(0, 2)?.toUpperCase()}</span>
                                                        </div>
                                                    }
                                                >
                                                    <div className={style.notification_info_wp}>
                                                        <p className={style.message}>{v?.message}</p>
                                                        <div className={style.date_time_wp}>
                                                            <div className={style.date}>
                                                                <Image src="/images/icons/time.svg" height="18" width="18" alt="time icon" /> {dateOnlyFormat(v?.createdAt)}
                                                            </div>
                                                            <div className={style.time}>
                                                                <Image src="/images/icons/date.svg" height="18" width="18" alt="date icon" /> {timeFormat(v?.createdAt)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Menu.Item>
                                            ))}
                                        </ScrollArea>
                                    </>
                                )}
                                <div className={style.notification_actions}>
                                    <Link href={`/notification-alert`} onClick={() => clearAllNotification()} title="See all Notification" className="see_all_btn">
                                        {common?.see_all}
                                    </Link>
                                    <button className="clear_all_btn" onClick={() => clearAllNotification()} disabled={notificationData?.length == 0 || loading}>
                                        {common?.clear_all}
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </Menu.Dropdown>
            </Menu>
        </>
    );
};

export default Notifications;
